import { Currency, toUnit } from 'common/utils/currency';
import React from 'react';
import { FormattedNumber } from 'react-intl';

export default function Price({ amount, currency }: { amount: number; currency: Currency }) {
    return (
        <FormattedNumber
            value={toUnit(amount, currency)}
            style="currency"
            currency={currency}
            minimumFractionDigits={0}
        />
    );
}
